import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { CourseDetail } from './templates/CourseDetail/CourseDetail';
import * as Styled from './CourseDetails.style';
// --- MOCKS ESPECÍFICOS DO COURSE DETAIL ---
const richTextMock = `
  <h4>Sobre o curso</h4>
  <div style="display: flex; align-items: center; margin: 16px 0;">
    <img src="https://ava.sebrae.com.br/Imagens/logos_alura_google_sebrae.png" alt="Parceiros" width="420" />
  </div>
  <p><em>Imersão online ensina como usar Google Ads, Gemini e Business Profile para ampliar vendas e competitividade!</em></p>
  <p>Para impulsionar a eficiência e a produtividade dos pequenos negócios, <strong>Alura + FIAP Para Empresas, Google e Sebrae</strong> anunciam a 2ª edição da "Imersão Empreendedora em IA". Gratuito, online e com certificado de participação para quem assistir todas as aulas na plataforma, o programa oferece capacitação prática em ferramentas digitais, preparando empreendedores de MPEs para aproveitar datas estratégicas do segundo semestre do ano, como Black Friday e Natal. As inscrições ficam abertas de 23 de outubro a 30 de novembro.</p>
  <p>Com uma live de abertura exclusiva. O conteúdo é voltado a empreendedores com nível iniciante ou intermediário em tecnologia, interessados em fortalecer a presença digital e ampliar resultados de forma acessível.</p>
  <p>Durante a imersão, os participantes terão acesso a orientações práticas sobre como aplicar o Google Gemini, o Google Business Profile e o Google Ads, além de estratégias de empreendedorismo, para automatizar processos, aumentar a visibilidade online, aprimorar a tomada de decisões estratégicas e potencializar vendas com o apoio da Inteligência Artificial.</p>
  <p>Confira o regulamento <a href="#">AQUI</a>.</p>
  <p><a href="#">Clique para Criar ou atualizar o perfil da sua empresa no Google</a></p>
  <p>Ao final da imersão:</p>
  <p>Você será desafiado(a) a aplicar os conhecimentos em um projeto prático para potencializar seu negócio com IA.</p>
  <p>Não perca essa oportunidade única: matrículas abertas até 30/11 e participação nas aulas até 07/12!</p>
`;
const programmaticContentMock = [
    { date: '23/10', title: 'Imersão Empreendedora: A Oportunidade no Final do Ano e os 3As do Perfil Campeão - AO VIVO' },
    { date: '27/10', title: 'Na prática: Gerar visibilidade e otimizar com IA do Google' },
    { date: '28/10', title: 'Marketing com IA: Potencializar sua visibilidade com anúncios do google' },
    { date: '29/10', title: 'Casos por Indústria: Potencializando por indústria olhando para Black Friday' },
    { date: '30/10', title: 'Eficiência com IA: Vender mais no google shopping, e dicas para atendimento e finanças.' },
];
const enrollmentCardMock = {
    imageSrc: 'https://ava.sebrae.com.br/App/Api/Training/Training/GetTrailImageBase64?idTraining=5318',
    status: 'Aprovado',
    progress: 100,
    courseWorkload: '5 h',
    enrollmentDate: '22/10/2025',
    deadlineDate: '07/12/2025',
    buttonText: 'Certificado',
    isInEditor: false,
    cqPath: '',
};
const MOCK_TABS = [
    { label: 'Informações', value: 'informacoes' },
    { label: 'Sala de Aula', value: 'sala-de-aula' },
    { label: 'Avaliações', value: 'avaliacoes' },
];
// --- COMPONENTE DE PÁGINA ---
export const CourseDetailsPage = () => {
    const [selectedTab, setSelectedTab] = useState('informacoes');
    const [selectedTag, setSelectedTag] = useState('EMPREENDEDORISMO');
    const handleTabChange = (tab) => {
        console.log('Tab alterada para:', tab);
        setSelectedTab(tab);
    };
    const handleTagChange = (tag) => {
        console.log('Tag alterada para:', tag);
        setSelectedTag(tag);
    };
    return (_jsx(Styled.Fragment, { children: _jsx(CourseDetail, { selectedTag: selectedTag, type: "Curso | ", title: "Imers\u00E3o Empreendedora Sebrae", tabs: MOCK_TABS, selectedTab: selectedTab, enrollmentCardProps: enrollmentCardMock, richTextContent: richTextMock, programmaticContent: programmaticContentMock, onTabChange: handleTabChange, onTagChange: handleTagChange }) }));
};
//# sourceMappingURL=CourseDetails.js.map